import React, { useState, useEffect } from 'react';
import {
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Breadcrumbs,
  Link,
  Select,
  MenuItem,
  FormControl,
} from '@material-ui/core';
import { useParams, useHistory } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import styled from 'styled-components';
import { format } from 'date-fns';
import Pagination from '@material-ui/lab/Pagination';
import { useDispatch } from 'react-redux';
import { showError } from '@actions/global';

const RecordsPage = () => {
  const { runId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ results: [], recordCount: 0 });
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    fetchData();
  }, [page, filter]);

  const fetchData = async () => {
    try {
      let url = `/prodigyappraisalnotices/electronicdeliveryportalnotificationrun/${runId}/details?page=${page}&pageSize=${pageSize}`;
      if (filter !== 'All') {
        url += `&filter=${filter}`;
      }
      
      const response = await fetch(url, {
        headers: {
          'Authorization': localStorage.getItem('token'),
        },
      });
      const json = await response.json();
      setData(json);
    } catch (error) {
      dispatch(showError('Error fetching records'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link
          color="inherit"
          onClick={() => {
            history.push('/appraisal-process-manager/electronic-delivery-requests-portal-notifications');
          }}
        >
          Portal Notification Runs
        </Link>
        <Typography color="textPrimary">
          {runId}
        </Typography>
        <Typography color="textPrimary">
          Records
        </Typography>
      </Breadcrumbs>

      <Header>
        <Typography variant="h6">Notification Records</Typography>
        <FormControl variant="outlined" style={{ minWidth: 120 }}>
          <Select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <MenuItem value="All">All</MenuItem>
            <MenuItem value="Success">Success</MenuItem>
            <MenuItem value="Error">Error</MenuItem>
          </Select>
        </FormControl>
      </Header>

      {loading ? (
        <LoadingContainer>
          <CircularProgress />
        </LoadingContainer>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Detail ID</TableCell>
                  <TableCell>Request ID</TableCell>
                  <TableCell>Notification ID</TableCell>
                  <TableCell>Start Date</TableCell>
                  <TableCell>End Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Error Message</TableCell>
                  <TableCell>Property ID</TableCell>
                  <TableCell>Owner Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.results.map((row) => (
                  <TableRow key={row.detailID}>
                    <TableCell>{row.detailID}</TableCell>
                    <TableCell>{row.requestID}</TableCell>
                    <TableCell>{row.notificationID}</TableCell>
                    <TableCell>{row.startDt && format(new Date(row.startDt), 'MM/dd/yyyy HH:mm:ss')}</TableCell>
                    <TableCell>{row.endDt && format(new Date(row.endDt), 'MM/dd/yyyy HH:mm:ss')}</TableCell>
                    <TableCell>{row.hasError ? 'Error' : 'Success'}</TableCell>
                    <TableCell>{row.errorMessage}</TableCell>
                    <TableCell>{row.pID}</TableCell>
                    <TableCell>{row.ownerName}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Pagination
            count={Math.ceil(data.recordCount / pageSize)}
            page={page}
            onChange={(e, newPage) => setPage(newPage)}
          />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
`;

export default RecordsPage; 